import React, { FC } from 'react';
import { GroupStudentSeriesScores, SeriesScores } from '../../../../config/api/models/Score';
import { useUser } from '../../../shared';
import TrajectoryExercisesEvaluationSeriesListView from './TrajectoryExercisesEvaluationSeriesListView';
import TrajectoryExercisesEvaluationDetailView from './TrajectoryExercisesEvaluationDetailView';
import WorkSheet from '../TrajectoryDetail/WorkSheet';
import { ExerciseSeriesType } from '../../../../config/api/models/Exercise';
import { Theme, styled } from '@material-ui/core';

type Props = {
  type: ExerciseSeriesType;
  seriesId: string;
  trajectoryScoresByUser?: Record<string, SeriesScores>;
  trajectoryScoresByStudent?: Record<string, SeriesScores>;
  trajectoryScoresByGroup?: GroupStudentSeriesScores;
  onExpandedChanged?: () => void;
};

const Wrapper = styled('div')<Theme>(({ theme }) => ({
  paddingTop: theme.spacing(1),
}));

const WorkSheetWrapper = styled('div')<Theme>(({ theme }) => ({
  paddingTop: theme.spacing(2),
}));

const TrajectoryExercisesEvaluationPageView: FC<Props> = ({
  type,
  seriesId,
  trajectoryScoresByUser,
  trajectoryScoresByStudent,
  trajectoryScoresByGroup,
  onExpandedChanged,
}) => {
  const { isStudent } = useUser();

  return (
    <Wrapper>
      {seriesId ? (
        <TrajectoryExercisesEvaluationDetailView
          type={type}
          teacherProgressAndScores={trajectoryScoresByGroup}
          onExpandedChanged={onExpandedChanged}
        />
      ) : (
        <TrajectoryExercisesEvaluationSeriesListView
          studentProgressAndScores={isStudent ? trajectoryScoresByUser : trajectoryScoresByStudent}
          teacherProgressAndScores={trajectoryScoresByGroup}
          type={type}
        />
      )}
      <WorkSheetWrapper>
        <WorkSheet type={type} readOnly />
      </WorkSheetWrapper>
    </Wrapper>
  );
};

export default TrajectoryExercisesEvaluationPageView;
